<template>
    <b-media no-body class="py-3">
        <b-media-aside class="mr-0">
            <BlockIcon :icon="block.icon" />
        </b-media-aside>
        <b-media-body class="w-100 d-flex align-items-center">
            <BlockTitle :title="block.name" />
            <AttributesDropdown
                v-model="attribute"
                @input="$emit('change', $event)"
                :attributes="block.attributes"
                class="attributes-dropdown"
            />
        </b-media-body>
    </b-media>
</template>

<script>
import { BlockIcon, BlockTitle, AttributesDropdown } from './components'
import { mapGetters } from 'vuex'

export default {
    name: 'Block',
    components: {
        BlockIcon,
        BlockTitle,
        AttributesDropdown,
    },
    props: {
        queryParams: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            block: {},
            attribute: {},
        }
    },
    created() {
        const { blockId, attributeId } = this.queryParams
        this.block = this.getBlock(blockId)
        this.attribute = this.block.attributes.find((attribute) => {
            return attribute.id == attributeId
        })
    },
    computed: {
        ...mapGetters('strategy', ['getBlock']),
    },
}
</script>

<style lang="scss" scoped>
.attributes-dropdown {
    max-width: calc(100% - 62px);
}
</style>
